import { useMemo } from "react";

import { OptionType } from "commons/ui/input/Select";

function useProjectCategories() {
    return useMemo(
        (): OptionType[] => [
            { value: "", label: "" },
            { value: "Strade", label: "Strade" },
            { value: "Opere olimpiche", label: "Opere olimpiche" },
            { value: "Altro", label: "Altro" },
        ],
        [],
    );
}

export default useProjectCategories;
